// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"a7fec05a","725":"9e58df69"}[chunkId] + ".chunk.js";
};